// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"154":"3e8010ac","346":"66d9b669","381":"3c5c311c","453":"356d5f7e","675":"8bac94e7","954":"085efafa"}[chunkId] + ".chunk.js";
};